import axios from "axios";
import { config_headers, URL_API, servicelist } from "../Config";

export const pCommitteeDashboard = async (body) => {
    return new Promise(async (resolve, reject) => {
        try {
            let authorization = await config_headers();
            // console.log('authorization ',authorization.headers , body);
            await axios.post(URL_API(`${servicelist.committeeService}/p_committee_dashboard `), body, authorization).then((res) => {
                resolve(res.data);
            });
        } catch (err) {
            reject(err);
        } finally {
        }
    });
};
